export enum WEBAPP_FLAGS {
  whatsappBot = 'whatsappBot',
  validacaoChassi = 'validacaoChassi'
}

export function useWebappFlags(): {
  flags: Promise<Map<string, { dataAttr: string; isActive?: string }>>;
  getFlagOnSession: (key: keyof typeof WEBAPP_FLAGS) => boolean;
} {
  const root = document.getElementById('root');
  const flagsMap = new Map<string, { dataAttr: string; isActive?: string }>();

  flagsMap.set(WEBAPP_FLAGS.whatsappBot, {
    dataAttr: 'data-whatsapp-bot',
    isActive: process.env.REACT_APP_ACTIVE_WHATSAPP_BOT
  });

  flagsMap.set(WEBAPP_FLAGS.validacaoChassi, {
    dataAttr: 'data-validacao-chassi',
    isActive: process.env.REACT_APP_ACTIVE_VALIDACAO_CHASSI
  });

  flagsMap.forEach((flag, currentFlagName) => {
    if (flag.isActive != 'true') {
      return;
    }
    if (root && root.hasAttribute(flag.dataAttr)) {
      sessionStorage.setItem(currentFlagName, 'true');
    } else {
      sessionStorage.removeItem(currentFlagName);
    }
  });

  function getFlagOnSession(key: keyof typeof WEBAPP_FLAGS) {
    const flag = flagsMap.get(key);
    if (!flag || flag.isActive !== 'true') {
      return false;
    }
    return !!sessionStorage.getItem(key);
  }

  return {
    flags: Promise.resolve(flagsMap),
    getFlagOnSession
  };
}
